import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/shared/lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  testID?: string;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, testID, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      data-testid={testID}
      className={cn('rounded-card bg-surface-high p-4 shadow-card', className)}
      {...props}
    />
  );
});

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mb-3 flex items-center justify-between', className)} {...props} />;
}

export function CardTitle({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 className={cn('text-display-sm text-on-surface', className)} {...props}>
      {children}
    </h3>
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-body-md text-secondary-text', className)} {...props} />;
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mt-4 flex items-center gap-3', className)} {...props} />;
}
